// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__SUjJB","img1":"Footer_img1__g7jn-","img2":"Footer_img2__1v-jo","img3":"Footer_img3__+D37T","img4":"Footer_img4__9-l6z"};